import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import ImageTag from "../components/reuseable/imageTag";
import FormSection from "../components/login-form/loginForm";
import { UserLogoutAction } from "../Store/Actions/AuthActions";

function Login() {
  const dispatch = useDispatch();
  const hasCheckedSession = useRef(false);

  useEffect(() => {
    // Only check once on mount to prevent multiple toasts
    if (hasCheckedSession.current) return;
    
    // Check if accessToken exists - if so, clear it and show session expired message
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      hasCheckedSession.current = true;
      // Clear all auth data
      dispatch(UserLogoutAction());
      // Show session expired toast
      toast.error("Session expired. Please login again.", {
        duration: 4000,
      });
    }
  }, [dispatch]);

  return (
    <div className="lg:h-screen flex items-center">
      <div className="flex w-full lg:h-screen rounded-xl">
        <div className="w-[60%] h-full hidden lg:flex lg:flex-col items-center justify-center bg-gradient-to-b from-[#3FC4E3] to-[#006077]">
          <ImageTag
            path="/assets/images/auth/thumbnail.png"
            classes="size-[460px]"
            altText="login"
          />
          <p className="font-popinsBold text-white text-4xl mt-8 text-center">
            One Platform.
          </p>
          <p className="font-popinsBold text-white text-4xl mt-2 text-center">
            Endless Community Possibilities.
          </p>
        </div>
        <div className=" w-full lg:w-[40%] h-screen lg:h-full my-auto flex flex-col items-center justify-center bg-bg-auth bg-no-repeat bg-center bg-cover">
          <div className="w-[90%] lg:w-[75%] mx-auto flex flex-col items-center justify-center">
            <div className="w-full pt-8 h-full flex flex-col justify-center text-center">
              <h1 className="font-popinsBold  text-2xl 2xl:text-4xl">
                Hello Again
              </h1>
              <p className="text-textColor mb-4 w-[70%] mx-auto mt-2">
                Welcome back, before logging in, make sure you enter the account correctly.
              </p>
              <FormSection />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
